export const MOVE_TO_OTHER_ACCOUNT_REQUEST = "MOVE_TO_OTHER_ACCOUNT_REQUEST";
export const MOVE_TO_OTHER_ACCOUNT_RESULT = "MOVE_TO_OTHER_ACCOUNT_RESULT";
export const MOVE_TO_OTHER_ACCOUNT_OPEN_MODAL = "MOVE_TO_OTHER_ACCOUNT_OPEN_MODAL";
export const MOVE_TO_OTHER_ACCOUNT_CLOSE_MODAL = "MOVE_TO_OTHER_ACCOUNT_CLOSE_MODAL";
export const MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST = "MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_REQUEST";
export const MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_RESULT = "MOVE_TO_OTHER_ACCOUNT_GET_DEVICE_RESULT";

export const MOVE_TO_OTHER_ACCOUNT_SET_DEVICE = "MOVE_TO_OTHER_ACCOUNT_SET_DEVICE";

